import { TChatRoom } from "./chatType";

export const mapRoomsToConversations = (
  rooms: TChatRoom[],
  myUserId: string,
  myRole: "client" | "creator",
): TChatRoom[] => {
  return rooms.map((room) => {
    const otherUser = myRole === "client" ? room.creator_id : room.client_id;

    return {
      ...room,
      name: otherUser.fullName,
      avatar: otherUser.profileImage,
      lastMessage: room.last_message?.content || "No messages yet",
      timestamp: room.last_message?.timestamp || room.updatedAt,
      unreadCount: 0, // later from backend
      isOnline: true, // later from socket presence
    };
  });
};
